import {
  finishBuildBag,
  getLogisticsInfoList,
  setContainerBoxInfo,
  setLogisticstInfo,
  setSmallBagWeight,
} from "@/apis/outStock";
import { audioPay } from "@/utils/tools";
import { Loading } from "element-ui";

export const smallContainer = {
  data() {
    return {
      timer: null,
      packageNums: 1, //
      weight: null, //
      deliveryBoxId: null,
      logisticsCode: null,
      insidePackCode: null,
      newLogisticsCode: null,
      logisticsCompanyCode: null,
      logisticsCompanyName: null,
      deliveryTaskLogisticsDetailId: null,
      priceLimit: "",
      weightLimit: "",
    };
  },
  methods: {
    // 页面一进来就刷新，判断有没有容器和箱子， 没有就对应的去新增，新增完后刷新一次。保证一定有容器和箱子
    // 判断是否生成容器（与大件装箱逻辑一样，只不过不在界面展示）
    getLogisticsInfo: function () {
      const that = this;
      getLogisticsInfoList({ deliveryTaskCode: that.deliveryTaskCode }).then(
        ({ code, data = [] }) => {
          if (code === 0) {
            if (!!data && !!data.length) {
              // 有容器就赋值
              const container = data[0];
              const {
                packageNums,
                logisticsCode,
                insidePackCode,
                logisticsCompanyCode,
                logisticsCompanyName,
                deliveryTaskLogisticsDetailId,
                deliveryBoxList,
                weightLimit,
                priceLimit,
                logisticsTagUrl
              } = container;
              that.packageNums = packageNums;
              that.logisticsCode = logisticsCode;
              that.newLogisticsCode = logisticsCode;
              that.insidePackCode = insidePackCode;
              that.logisticsCompanyCode = logisticsCompanyCode;
              that.logisticsCompanyName = logisticsCompanyName;
              that.deliveryTaskLogisticsDetailId =
                deliveryTaskLogisticsDetailId;
              this.weightLimit = weightLimit;
              this.priceLimit = priceLimit;
              if (!!deliveryBoxList && !!deliveryBoxList.length) {
                that.weight = !!Number(deliveryBoxList[0].weight)?deliveryBoxList[0].weight:'';
                that.deliveryBoxId = deliveryBoxList[0].deliveryBoxId;
                that.deliveryBoxCode = deliveryBoxList[0].deliveryBoxCode;
              } else {
                // that.createBox().then(({code, data}) => {
                //     // 新增后刷新下
                //     that.getLogisticsInfo()
                // })
              }
              

              if (logisticsTagUrl) {
                if (that.wmsIntForwarderConfigId) {
                  that.$printSheet(that.wmsIntForwarderConfigId, [logisticsTagUrl]).then(res => {
                    console.log(res)
                  }).catch(res => {
                    openPdf(logisticsTagUrl)
                  })
                  return
                }
                openPdf(logisticsTagUrl)
              } else {
                this.$message.warning('无物流面单，请线下处理')
              }

                  
              function openPdf(url){
                window.open(url + '?response-content-type=application/pdf')
              }
            } else {
              // 没有容器就新建
              // that.createContainer().then(({code, data}) => {
              //     if (code === 0) {
              //         that.createBox(data).then(({code, data}) => {
              //             // 新增后刷新下
              //             that.getLogisticsInfo()
              //         })
              //     }
              // })
            }
          }
        }
      );
    },
    // 生成容器
    createContainer: function () {
      const that = this;
      const params = {
        deliveryTaskCode: that.deliveryTaskCode,
      };
      return setLogisticstInfo(params);
    },
    // 新增箱子
    createBox: function (insidePackCode) {
      const that = this;
      const params = {
        deliveryTaskCode: that.deliveryTaskCode,
        insidePackCode,
      };
      return setContainerBoxInfo(params);
    },
    // 手填物流单号
    setShipNumber: function () {
      const that = this;
      const params = {
        deliveryTaskLogisticsDetailId: that.deliveryTaskLogisticsDetailId,
        deliveryTaskCode: that.deliveryTaskCode,
        logisticsCode: that.newLogisticsCode,
      };
      setLogisticstInfo(params).then((res) => {
        const { code = -1, msg } = res;
        if (code === 0) {
          // 手动设置物流单号成功
          that.shipmentNumber = that.newShipmentNumber;
          that.$message.success("物流号更新成功！");
        } else {
          // 手动设置物流单号成功
          that.newShipmentNumber = that.shipmentNumber;
          that.$message.error("物流号更新失败！");
        }
      });
    },
    // 防抖
    antiShake: function (fun, val) {
      clearTimeout(this.timer);
      this.timer = setTimeout((_) => {
        fun(val);
      }, 500);
    },
    //创建
    createContainerAndBox() {},
    // 称重
    weightSet: function (val) {
      const that = this;
      if(that.weight == val){
        return
      }
      if(isNaN(val)){
        this.$message.warning('请输入数字')
        return 
      }
      function nextStep(){
        const params = {
          deliveryTaskCode: that.deliveryTaskCode,
          weight: val,
          deliveryBoxId: that.deliveryBoxId,
          insidePackCode: that.insidePackCode,
        };
        setSmallBagWeight(params).then(({ code, data }) => {
          if (code === 0) {
            that.weight = val;
            if(data.needNotice) {
              that.$confirm(data.message, "提示", {
                confirmButtonText: "确认",
                type: "warning",
                cancelButtonText: "取消",
              })
              that.getDetails();
            } else {
              that.$message.success(`重量: ${that.weight} g`);
            }
            if(data.shipIsChanged) {
              return
            }
            that.buildFinish()
          }
        });
      }
      if(val || val === 0){
        console.log(val, val > 200)
        if(val > 200){
          nextStep()
          return
        }
        setTimeout(() => {
          that.$confirm(`重量${val}克，是否提交`, "提示", {
            confirmButtonText: "确认",
            type: "warning",
            cancelButtonText: "取消",
            closeOnPressEscape: false,
            closeOnClickModal: false
          }).then(() => {
            nextStep()
          }).catch(() => {
            console.log(123)
          });
        }, 100);

      }
    },
    // 设置包裹数量
    bagNumChange: function (val) {
      const that = this;
      if (!val) {
        that.$message.error("包裹数不能为 0");
        return;
      }
      if (!!that.insidePackCode) {
        // 有容器设置容器的包裹数量
        const that = this;
        const params = {
          // todo
          packageNums: val,
          deliveryTaskCode: that.deliveryTaskCode,
          deliveryTaskLogisticsDetailId: that.deliveryTaskLogisticsDetailId,
        };
        setLogisticstInfo(params).then(({ code }) => {
          if (code === 0) {
            that.$message.success("成功");
            that.packageNums = val;
          }
        });
      }
    },
    buildFinish: function () {
      const that = this;
      if (that.weight === null) {
        that.$message.error("请填写包裹重量！");
        return;
      }
      function openPdf(url){
        window.open(url + '?response-content-type=application/pdf')
      }
      if(that.interceptStatus == 1){
        setTimeout(() => {
          that.$confirm('<div style="color:red">该发货单已被拦截，请单独放置</div>','拦截提示',{
            showCancelButton: false,
            dangerouslyUseHTMLString: true,
            closeOnClickModal:false,
            closeOnPressEscape: false
          })
          }, 300);
      }
      
      const arr = Object.keys(that.boxSizeInfo).map(v => that.boxSizeInfo[v])
      if(arr.some(v => v) && arr.some(v => !v)){
        that.$message.warning('请输入长宽高')
        return
      }
      function errorNum(v){
        return isNaN(v) || !Number.isInteger(Number(v)) || v < 1 
      }
      if(arr.every(v => v) && arr.some(v => errorNum(v))){
        that.$message.warning('请输入正确的长宽高')
        return
      }
      finishBuildBag({ 
        deliveryTaskCode: that.deliveryTaskCode,
        ...that.boxSizeInfo
      }).then(
        ({ code, data }) => {
          if (code === 0) {
            audioPay(`完成`);
            that.$refs['ScanQuery'].focusIpt()
            that.$message.success("打包完成");
            that.query.code = "";
            that.weight = "";
            that.additionalDataSource = [];
            that.productDataSource = [];
            that.boxSizeInfo = {}
            that.customerTagName = ''
            // if (data.logisticsTagUrl) {
            //   if(that.companyCode){
            //     that.$printSheet(that.companyCode,data.logisticsTagUrl).then(res=>{
            //     }).catch(res=>{
            //       openPdf(data.logisticsTagUrl)
            //     })
            //     return
            //   }
            //   openPdf(data.logisticsTagUrl)
            // }else{
            //   this.$message.warning('无物流面单，请线下处理')
            // }
            // that.companyCode = ''
          }
        }
      );
    },
    pdfLoaded() {
      const that = this;
      let loadingInstance = Loading.service({ text: "加载中" });
      that.$refs.printPdf.print();
      loadingInstance.close();
    },
  },
};
